import React, { Component, useState, useEffect } from 'react';





var responseData = new Object();




export function setByName(apiName, resData) {
  responseData[apiName] = resData;
}


export function retrieveByName(apiName, paramName, pathName) {

  while (paramName.charAt(0) == '-') {
    paramName = paramName.substring(1);
    apiName = apiName.substring(0, apiName.lastIndexOf('.'));
  }


  var countSharp = 0;
  for (var i = 0; i < paramName.length; i++) {
    if (paramName.indexOf('#', countSharp) >= 0) {
      countSharp++;
    } else {
      break;
    }
  }

  var dataObject = responseData[apiName];

  var params = null;
  if (countSharp > 0) {
    paramName = paramName.substring(countSharp);
    params = (paramName || '').split('.');
    var paths = (pathName || '').split('.');
    var pathLen = paths.length;
    for (var i = 1; i < countSharp; i++) {
      for (var j = pathLen - 2; j >= 0; j--) {
        if (paths[j].indexOf('|') >= 0) {
          pathLen = j + 1;
          break;
        }
      }
    }

    var tempArr = new Array;
    for (var i = 0; i < pathLen; i++) tempArr[i] = paths[i];
    for (var i = 0; i < params.length; i++) tempArr[pathLen + i] = params[i];

    params = tempArr;
  } else {
    params = (paramName || '').split('.');
  }


  var temp = dataObject;
  for (var i = 0; i < params.length; i++) {
    var ii = params[i].indexOf('|');
    if (ii >= 0) {
      var s = params[i].substring(0, ii);
      var n = parseInt(params[i].substring(ii + 1));
      temp = temp[s][n];
    } else {
      temp = temp[params[i]];
    }
    if (!temp) break;
  }

  return temp;
}




const ApiManager = (props) => {
  return (
    <div>
      {props.children}
    </div>
  );
}
export default ApiManager;
